import * as api from '../../api';

export const verifyUnsubTokenActions = api.fetchActions('opt-out', 'verify-unsub-token');
export const redeemUnsubTokenActions = api.fetchActions('opt-out', 'redeem-unsub-token');


export const actionTypes = {
  ...verifyUnsubTokenActions.actionTypes,
  ...redeemUnsubTokenActions.actionTypes
};

/**
 * Confirm validity of a the given unsubscription token.
 * If the token is expired or already redeemed, an error
 * is returned. If the token is valid, success is returned.
 * @param {string} token The unsubscription token guid to verify.
 */
export const verifyUnsubToken = (token) => api.getThunk(
  `/campaigns/verify-opt-out`,
  {
    token
  },
  verifyUnsubTokenActions,
  {},
  api.unauthorizedConfig);

/**
 * Use the supplied token to perform an unsubscription.
 * This will invalidate this token from future use.
 * @param {string} token The unsubscription token guid to redeem.
 */
export const redeemUnsubToken = (token) => api.postThunk(
  `/campaigns/opt-out/${token}`,
  {},
  redeemUnsubTokenActions,
  {},
  api.unauthorizedConfig);



// WEBPACK FOOTER //
// src/acct/opt-out/opt-out.actions.js